import React from 'react'
import { Upload, Modal, message } from 'antd'
import { UploadFile, UploadChangeParam } from 'antd/lib/upload/interface'
import { PlusOutlined } from '@ant-design/icons'
import { getBase64 } from '../../../utils'
import './index.less'

type fileUrlList = string[];

// TS2430 怎么处理比较好
export interface UploadImageFile extends UploadFile {
}

export interface UploadImageProps {
	limit: number; // 上传文件限制
	value?: fileUrlList; // 元素为文件链接
	onChange?: (value: fileUrlList) => void;
	accept: string; // 接收的文件类型 文件后缀名，逗号分隔
	describe: string; // 描述
}

export interface UploadImageState {
	previewVisible: boolean;
	previewImage?: string;
	previewTitle?: string;
	fileList: UploadImageFile[];
}

const initFileList = (list: string[]) => {
	const res = []
	for (let i = 0; i < list.length; i++) {
		const element = list[i]
		res.push({
			uid: element,
			url: element,
			name: element,
			size: 100,
			type: 'image/' // 已经上传的图片 必须设置type为'image/' 否则不会展示为缩略图
		})
	}
	return res
}

class UploadImage extends React.Component<UploadImageProps, UploadImageState> {
	static defaultProps = { // 指定默认值
		limit: 6,
		accept: '.jpg,.png',
		describe: '注：仅可上传jpg或png格式文件',
	}

	state: UploadImageState = {
		previewVisible: false,
		previewImage: '',
		previewTitle: '',
		fileList: this.props.value ? initFileList(this.props.value) : [],
	}
	componentDidUpdate(prevProps) {

		if(prevProps.value !== this.props.value) {
			initFileList(this.props.value)
			this.setState({
				// fileList: this.props.value
			})
		}
	}
	handleCancel = (): void => this.setState({ previewVisible: false })

	handlePreview = async (file: UploadImageFile): Promise<any> => {
		if (!file.url && !file.preview && file.originFileObj) {
			file.preview = await getBase64(file.originFileObj)
		}

		this.setState({
			previewVisible: true,
			previewImage: file.url || file.preview,
			previewTitle: file.name || (file.url && (file.url.substring(file.url.lastIndexOf('/') + 1))),
		})
	}

	handleChange = ({ fileList }: UploadChangeParam): void => {
		console.log('fileList: ', fileList)
		this.setState({ fileList })

		const list: fileUrlList = []
		fileList.forEach(file => {
			if (file.response) {
				const { code, data, msg } = file.response
				if (code === 0) {
					list.push(data)
				} else {
					message.error(msg || '上传失败！请稍后重试')
				}
			}
		})
		this.triggerChange(list)
	}

	triggerChange = (fileList: fileUrlList): void => {
		const { onChange } = this.props
		onChange && onChange(fileList)
	}

	render() {
		const { previewVisible, previewImage, fileList, previewTitle } = this.state
		const { limit, accept, describe } = this.props
		const uploadButton = (
			<div>
				<PlusOutlined style={{fontSize: '20px', color: '#CED8E6', marginTop: '4px'}} />
			</div>
		)
		return (
			<div className="clearfix upload-image">
				<Upload
					action={`${process.env.REACT_APP_BASE_URL}/infoManage/addFile`}
					listType="picture-card"
					fileList={fileList}
					accept={accept}
					withCredentials={true}
					onPreview={this.handlePreview}
					onChange={this.handleChange}
				>
					{fileList.length >= limit ? null : uploadButton}
				</Upload>
				<span className="describe" style={{ fontSize: '12px' }}>{describe}</span>
				<Modal
					visible={previewVisible}
					title={previewTitle}
					footer={null}
					onCancel={this.handleCancel}
				>
					<img alt="example" style={{ width: '100%' }} src={previewImage} />
				</Modal>
			</div>
		)
	}
}

export default UploadImage